interface ProjectsSectionProps {
  lang: 'pt' | 'en';
}

export function ProjectsSection({ lang }: ProjectsSectionProps) {
  const content = {
    pt: {
      label: 'RESULTADOS ESPERADOS',
      headline: 'O impacto no teu negócio.',
      subheadline: 'Resultados baseados em benchmarks do sector para negócios equivalentes.',
      cards: [
        {
          tag: 'CLÍNICA DENTÁRIA',
          company: 'Cenário Ilustrativo',
          metrics: [
            { value: '+320%', label: 'conversão de leads' },
            { value: '<2min', label: 'tempo de resposta automática' },
          ],
          text: 'Conversão 22%→51%. +€3.800/mês em receita recuperada.',
        },
        {
          tag: 'IMOBILIÁRIO',
          company: 'Cenário Ilustrativo',
          metrics: [
            { value: '+41%', label: 'leads qualificados' },
            { value: '28min', label: 'tempo de resposta (era 4h)' },
          ],
          text: '38% leads frios convertidos. 2 negócios extra em 6 semanas.',
        },
        {
          tag: 'CLÍNICA DE ESTÉTICA',
          company: 'Cenário Ilustrativo',
          metrics: [
            { value: '+290%', label: 'marcações mensais' },
            { value: '€1.200', label: 'ticket médio' },
          ],
          text: 'Marcações: 8→31/mês. +€8.400/mês em 60 dias.',
        },
      ],
      disclaimer:
        'Valores ilustrativos baseados em estudos de Lead Response Management e benchmarks do sector.',
    },
    en: {
      label: 'EXPECTED RESULTS',
      headline: 'What our systems deliver.',
      subheadline: 'Results based on industry benchmarks for equivalent businesses.',
      cards: [
        {
          tag: 'DENTAL CLINIC',
          company: 'Illustrative Scenario',
          metrics: [
            { value: '+320%', label: 'lead conversion' },
            { value: '<2min', label: 'automatic response time' },
          ],
          text: 'Conversion 22%→51%. +€3,800/month in recovered revenue.',
        },
        {
          tag: 'REAL ESTATE',
          company: 'Illustrative Scenario',
          metrics: [
            { value: '+41%', label: 'qualified leads' },
            { value: '28min', label: 'response time (was 4h)' },
          ],
          text: '38% cold leads converted. 2 extra deals in 6 weeks.',
        },
        {
          tag: 'AESTHETICS',
          company: 'Illustrative Scenario',
          metrics: [
            { value: '+290%', label: 'monthly bookings' },
            { value: '€1,200', label: 'average ticket' },
          ],
          text: 'Bookings: 8→31/month. +€8,400/month in 60 days.',
        },
      ],
      disclaimer:
        'Illustrative values based on Lead Response Management studies and industry benchmarks.',
    },
  };

  const c = content[lang];

  return (
    <section id="casos" className="py-24">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="mb-14 text-center">
          <p className="text-[11px] font-medium tracking-[0.15em] text-violet-400 uppercase mb-5">
            {c.label}
          </p>
          <h2 className="text-4xl md:text-[48px] font-light text-white tracking-[0.05em] mb-4">
            {c.headline}
          </h2>
          <p className="text-gray-400 text-base font-normal leading-[1.7] max-w-xl mx-auto">
            {c.subheadline}
          </p>
        </div>

        {/* 3-card grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          {c.cards.map((card, idx) => (
            <div
              key={idx}
              className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-8 flex flex-col gap-6"
            >
              {/* Tag + company */}
              <div className="flex flex-col gap-1">
                <span className="text-[10px] font-medium tracking-[0.15em] text-violet-400 uppercase">
                  {card.tag}
                </span>
                <span className="text-[12px] text-gray-500 font-light">{card.company}</span>
              </div>

              {/* Metrics */}
              <div className="flex gap-6">
                {card.metrics.map((m, mIdx) => (
                  <div key={mIdx} className="flex flex-col gap-0.5">
                    <span className="text-[36px] font-semibold leading-none bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">
                      {m.value}
                    </span>
                    <span className="text-[12px] text-gray-400 font-light leading-snug">
                      {m.label}
                    </span>
                  </div>
                ))}
              </div>

              {/* Divider */}
              <div className="border-t border-white/[0.08]" />

              {/* Result text */}
              <p className="text-gray-300 text-sm font-light leading-relaxed">{card.text}</p>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <p className="text-center text-[11px] text-gray-600 font-light leading-relaxed max-w-xl mx-auto">
          {c.disclaimer}
        </p>
      </div>
    </section>
  );
}
